import FacebookIcon from '@material-ui/icons/Facebook'
import TwitterIcon from '@material-ui/icons/Twitter'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import InstagramIcon from '@material-ui/icons/Instagram'

export const socialIcons = {
  Facebook: FacebookIcon,
  X: TwitterIcon,
  LinkedIn: LinkedInIcon,
  Instagram: InstagramIcon,
}
